import { CSSObject } from '@chakra-ui/react';
import { RaceDetailsSchema } from '@/views/races/RaceDetails/styles/RaceDetails.styles';

export const raceDetailsStyles: RaceDetailsSchema = {
  buttonStyledGroupedProps: {
    variant: 'odds',
    boxSize: '34px',
    minWidth: '34px',
    minHeight: '34px',
    sx: {
      '&[data-hasPromo="true"]': {
        minW: 12,
        '.btn-span': {
          pl: 0.5,
        },
      },
      '&[data-closed="true"][data-active="false"]': {
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: 'blackAlpha.300',
        bg: 'transparent',
        boxShadow: 'none',
        color: 'white',
        textShadow: 'none',
        p: '2.5',
      },
    },
  },
  flexExoticsHeadingRight: {
    alignItems: ['flex-end', 'center', 'center'],
  },
};

export const ButtonGroupWrapper: CSSObject = {
  gap: '1',
};

export const CountdownTimerContainer: CSSObject = {
  '.chakra-badge': {
    boxSizing: 'content-box',
  },
};

export const RaceAndTimerContainer: CSSObject = {
  bg: 'none',
  boxShadow: 'none',
  flexDir: ['row', 'row', 'row'],
  overflow: 'auto',
  py: '3',
  justifyContent: ['center', 'flex-start', 'flex-end'],
};

export const TextRaceConditions: CSSObject = {
  fontSize: 'xs',
  fontFamily: 'accent',
  fontWeight: 'medium',
  _after: {
    content: `""`,
    w: '1px',
    h: '4',
    bg: 'whiteAlpha.400',
    pos: 'relative',
    mx: '1.5',
  },
  span: {
    fontWeight: 'bold',
    mr: '1',
  },
};

export const RaceResultListWrapper: CSSObject = {
  gap: '2',
  mb: '2',
  flexDirection: 'column', 
};

export const ResultedStatusLabel: CSSObject = {
  color: 'beta.600',
  fontFamily: 'accent',
  fontWeight: 'bold',
  bg: 'beta.300',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  textTransform: 'uppercase',
};

export const RaceStatusText: CSSObject = {
  color: 'orange.800',
  bg: 'orange.400',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
};

export const RaceDetailsHeading: CSSObject = {
  color: 'white',
  textTransform: 'none',
  fontFamily: 'accent',
  fontSize: '0.7rem',
  fontStyle: 'normal',
  fontWeight: 'bold',
  lineHeight: 'normal',
  svg: {
    color: 'white',
  },
};

export const RaceRunnerListWrapper: CSSObject = {
  m: '0',
  py: '3',
};

export const RaceRunnerList: CSSObject = {
  bg: 'transparent',
  p: '0',
};

export const TextTitle: CSSObject = {
  fontFamily: 'accent',
  color: 'beta.300',
  textShadow: '0px 0px 8px rgba(254, 208, 119, 0.5)',
  fontSize: 'xl',
  fontStyle: 'normal',
  fontWeight: 'bold',
  lineHeight: 'normal',
  textTransform: 'uppercase',
};

export const RaceName: CSSObject = {
  fontFamily: 'accent',
  fontSize: 'xs',
  fontStyle: 'normal',
  fontWeight: 'bold',
  lineHeight: 'normal',
  textTransform: 'capitalize',
};

export const InfoContainer: CSSObject = {
  mb: '0',
  mt: '1',
  pb: '1.5',
};

export const RaceRunnerHeadingContainer: CSSObject = {
  columnGap: '0',
  '.chakra-switch__track': {
    background: 'alpha.700',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 2px 2px 0px rgba(0, 0, 0, 0.25) inset',
    '& .chakra-switch__thumb': {
      background: 'white',
      '&[data-checked]': {
        bg: 'alpha.100',
      },
    },
  },
  svg: {
    color: 'white',
  },
};

export const RaceRunnerListHeadings: CSSObject = {
  minH: '36px',
  mr: '1',
  pb: '2',
  alignItems: 'center',
};

export const RaceRunnerPropositionHeadingContainer: CSSObject = {
  '&&': {
    px: '0',
    w: '3.2rem',
  },
  svg: {
    color: 'white',
  },
  p: {
    w: 'auto',
  },
};

export const RaceRunnerWinPlaceContainer: CSSObject = {
  columnGap: '1',
  mb: '1',
  fontSize: ['2xs', null, 'sm'],
  fontWeight: 'medium',
};

export const ShowMoreText: CSSObject = {
  color: 'white',
  svg: {
    color: 'beta.300',
    textShadow: '0px 0px 8px rgba(254, 208, 119, 0.5)',
    fontSize: '2rem',
    paddingBottom: '5px',
    width: '0.7em',
  },
};
